import {
  withTranslation,
} from 'react-i18next';

import BannerFieldsView from './BannerFieldsView';

const TranslatedComponent = withTranslation()(BannerFieldsView);

const Component = TranslatedComponent;

export default Component;
